import { render, staticRenderFns } from "./SingleBarChart.vue?vue&type=template&id=337112a9"
import script from "./SingleBarChart.vue?vue&type=script&lang=ts"
export * from "./SingleBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports